/**
 * Email notification utilities for the Itunu platform
 */

export interface EmailTemplate {
  to: string;
  subject: string;
  template: string;
  data: Record<string, any>;
}

export interface NotificationData {
  type: string;
  title: string;
  message: string;
  data: Record<string, any>;
}

/**
 * Generate counsellor welcome email template
 */
export const generateCounsellorWelcomeEmail = (email: string): EmailTemplate => {
  return {
    to: email,
    subject: 'Welcome to Itunu - Counsellor Account Created',
    template: 'counsellor_welcome',
    data: {
      counsellorEmail: email,
      platformName: 'Itunu',
      loginUrl: `${window.location.origin}/signin`,
      supportEmail: 'support@itunu.com',
      welcomeMessage: `Welcome to Itunu! Your counsellor account has been created successfully. You can now log in and start helping patients.`
    }
  };
};

/**
 * Generate admin notification for new counsellor
 */
export const generateAdminNotification = (counsellorEmail: string, addedBy: string): NotificationData => {
  return {
    type: 'counsellor_added',
    title: 'New Counsellor Added',
    message: `A new counsellor has been added: ${counsellorEmail}`,
    data: {
      counsellorEmail,
      addedBy,
      addedAt: new Date().toISOString(),
      actionRequired: false
    }
  };
};

/**
 * Generate case assignment notification email
 */
export const generateCaseAssignmentEmail = (counsellorEmail: string, caseId: string, patientName: string): EmailTemplate => {
  return {
    to: counsellorEmail,
    subject: 'New Case Assigned - Itunu',
    template: 'case_assignment',
    data: {
      counsellorEmail,
      caseId,
      patientName,
      platformName: 'Itunu',
      caseUrl: `${window.location.origin}/cases/${caseId}`,
      supportEmail: 'support@itunu.com'
    }
  };
};

/**
 * Generate session notification email
 */
export const generateSessionNotificationEmail = (counsellorEmail: string, sessionId: string, patientName: string): EmailTemplate => {
  return {
    to: counsellorEmail,
    subject: 'New Session Started - Itunu',
    template: 'session_notification',
    data: {
      counsellorEmail,
      sessionId,
      patientName,
      platformName: 'Itunu',
      sessionUrl: `${window.location.origin}/sessions/${sessionId}`,
      supportEmail: 'support@itunu.com'
    }
  };
};
